import React from "react";
import PropTypes from "prop-types";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";

export default function Page(props) {
  return (
    <Container fluid>
      <Row className="align-items-center popout-element">
        <Col>
          <h2>{props.pageTitle}</h2>
        </Col>
        <Col></Col>
        {/*<Col xs="auto">
          <DayInfo />
        </Col>*/}
        {/*<Col xs="auto">
          <FeedbackModal />
        </Col>*/}
      </Row>
      {props.pageHeader ? (
        <Row className={props.ignoreStyleForHead ? "" : "popout-element"}>
          <Col xs="12">
            {props.alwaysShowHeader ? (
              props.pageHeader
            ) : (
              <Accordion>
                <Card style={{ border: "none" }}>
                  <Accordion.Toggle as={Button} variant="link" eventKey="0">
                    Filter
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    {props.pageHeader}
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            )}
          </Col>
        </Row>
      ) : null}
      <Row className={props.ignoreStyleForBody ? "" : "popout-element"}>
        {props.children}
      </Row>
    </Container>
  );
}

Page.propTypes = {
  alwaysShowHeader: PropTypes.bool,
  ignoreStyleForBody: PropTypes.bool,
  ignoreStyleForHead: PropTypes.bool,
  pageTitle: PropTypes.string.isRequired,
  pageHeader: PropTypes.object,
};
